// material-ui
import { Link, Container, Box, Grid, useTheme } from '@mui/material';
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import NationalEmblemImg from 'assets/images/national_emblem.png';
import { useHeaderVisibility } from 'hooks/useHeaderVisibility';
import { showError } from 'utils/common'; //,
import { API } from 'utils/api';

const Footer = ({ showFilings }) => {
  const siteInfo = useSelector((state) => state.siteInfo);
  const displayOneApi = useHeaderVisibility();
  const theme = useTheme();
  const [inputs, setInputs] = useState({
      FilingText: '',
      FilingLink: ''
    });

  const getOptions = async () => {
    const res = await API.get('/api/option/');
    const { success, message, data } = res.data;
    if (success) {
      let newInputs = {};
      data.forEach((item) => {
        if (item.key in inputs) {
          newInputs[item.key] = item.value;
        }
      });
      setInputs(newInputs);
    } else {
      showError(message);
    }
  };
    
  useEffect(() => {
    getOptions().then();
  }, []);

  return (
    <>
      {showFilings && (
        <Container sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '64px' }}>
          <Box sx={{ textAlign: 'center' }}>
            {siteInfo.footer_html ? (
              <div className="custom-footer" dangerouslySetInnerHTML={{ __html: siteInfo.footer_html }}></div>
            ) : (
              <>
                <Grid
                  sx={{
                    marginBottom: '40px',
                    display: 'flex',
                    justifyContent: 'center',
                    [theme.breakpoints.up('md')]: {
                      flexDirection: 'row',
                      marginBottom: '0px'
                    }
                  }}
                  style={{
                    height: '15px',
                    lineHeight: '15px',
                    display: 'flex',
                    alignItems: 'center',
                    color: '#00002280',
                    justifyContent: 'center',
                    marginTop: '20px',
                    flexWrap: 'wrap',
                    fontSize: '14px'
                  }}
                >
                  <Link
                    sx={{ color: '#00002280', textDecoration: 'none' }}
                    href={inputs.FilingLink}
                  >
                    {inputs.FilingText}
                  </Link>
                </Grid>
              </>
            )}
          </Box>
        </Container>
      )}
    </>
  );
};

export default Footer;
